<div class="home-page" (window:resize)="onResize()">
    <app-landing-pages [dataId]="'home-data'"></app-landing-pages>
</div>